module.exports = __webpack_public_path__ + "img/online-universities.e2993ca7.png";